export default __webpack_public_path__ + "static/media/fashive.cff25fb7.png";